import { motion } from "framer-motion";
import { Moon, Gem, Eye, Sparkles, PartyPopper } from "lucide-react";
import { SUPPORT } from "@/data";

const ease = [0.16, 1, 0.3, 1];
const ICONS = { moon: Moon, gem: Gem, eye: Eye, sparkles: Sparkles, party: PartyPopper };

export default function Support() {
  return (
    <section id="services" className="relative py-24 lg:py-36 bg-[#1A0F0B] border-y border-[#C9A24B]/12" data-testid="services-section">
      <div className="mx-auto max-w-[1200px] px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease }}
          className="flex items-center justify-center gap-3 mb-16 lg:mb-20"
        >
          <span className="h-px w-10 bg-[#C9A24B]/50" />
          <h2 className="text-[11px] sm:text-xs tracking-[0.4em] uppercase text-[#C9A24B] text-center">
            Ways I Can Support You
          </h2>
          <span className="h-px w-10 bg-[#C9A24B]/50" />
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-y-14 gap-x-6">
          {SUPPORT.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.key}
                initial={{ opacity: 0, y: 36 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: i * 0.1, ease }}
                className="group flex flex-col items-center text-center"
                data-testid={`service-${s.key}`}
              >
                <div className="mb-6 flex items-center justify-center w-16 h-16 rounded-full border border-[#C9A24B]/30 transition-all duration-500 group-hover:border-[#C9A24B]/70 group-hover:bg-[#C9A24B]/5">
                  <Icon className="w-7 h-7 text-[#C9A24B] glow-gold" strokeWidth={1} />
                </div>
                <h3 className="font-display text-2xl tracking-wide text-[#EFE3CC] mb-3">{s.title}</h3>
                <p className="text-sm text-[#B7A488] leading-relaxed font-light max-w-[240px]">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
